import React, { Fragment, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import _ from 'lodash'
import PropTypes from 'prop-types'
// COMPONENTS
import ModalSignOut from './ModalSignOut'
import AttachmentPopup from '../common/AttachmentPopup'

// CONSTANTS
import { MAX_SIZE_OF_FILE, MAX_SIZE_OF_FILE_BEFORE_UPLOAD } from 'constants/newBookingConstants'
import { UPLOAD_IMAGE, LOG_OUT_IMAGE, IMAGE_PLACE_HOLDER } from 'constants/imageConstants'

// Utils COMMON
import { Utils } from 'utils/Utils'
import { hideLoading, showLoading } from 'assets/javascripts/webapp-v2/common'
import toastr from 'utils/toast'
import { currentCustomerActionsCreator } from 'store/toolkit/currentCustomer/currentCustomer.reducer'
import { useTranslation } from 'react-i18next'
import CustomerAPI from 'api/customers'

import './PopupConfirmChangeInfo.scss'
import { FRESH_CHAT_TYPE_REQUEST_CHANGE_INFO, TEST_FEATURE_CHANGE_PHONE_EMAIL_CS } from 'constants/bookingConstants'
import CommonUtils from 'utils/common'

const checkAndUploadFile = (input, setIsShowImageErrorUpload) => {
  if(!input.files[0]) return
  const reader = new FileReader()
  const file = input.files[0]
  const image = new Image()
  const { size, name } = file
  const typeFile = file.type.split('/')
  reader.readAsDataURL(file)
  if (typeFile[0] === 'image' && size < MAX_SIZE_OF_FILE_BEFORE_UPLOAD) {
    reader.onloadend = () => {
      image.src = reader.result
      image.onload = () => {
        const compressedImage = Utils.compressImage(image, image.width, image.height, Utils.getQualityImage(size))
        const fileCompressImage = Utils.dataURLtoFile(compressedImage, name)
        if (fileCompressImage.size > MAX_SIZE_OF_FILE) {
          setIsShowImageErrorUpload(true)
          input.value = ''
        } else {
          document.getElementById('upload_image_view').setAttribute('src', reader.result)
        }
      }
    }
  } else if (size > MAX_SIZE_OF_FILE) {
    setIsShowImageErrorUpload(false)
    setIsShowImageErrorUpload(true)
    input.value = ''
  }
}

const generateFormData = (currentCustomer, params, t) => {
  let isValid = false
  const isHavePassword = !_.isEmpty(params.password) || !_.isEmpty(params.password_confirmation)
  const isEmptyPassword = _.isEmpty(params.password) && _.isEmpty(params.password_confirmation)

  if (_.isEmpty(params.password) && _.isEmpty(params.password_confirmation)) {
    delete params.current_password
    delete params.password
    delete params.password_confirmation
  }

  const formData = new FormData()
  Object.keys(params).forEach((key) => {
    if (currentCustomer[key] !== params[key]) {
      formData.append(key, params[key])
    }
  })
  if (params.avatar_square) {
    formData.append('avatar', params.avatar_square)
  }
  toastr.remove()
  if (isHavePassword) {
    if (_.isEmpty(params.current_password)) {
      toastr.info(t('error.messages.password_not_blank'))
      return null
    }
    isValid = Utils.isValidPassword(params.password, params.password_confirmation)
  }
  if (isValid || isEmptyPassword) return formData
  return  null
}

const formFieldWithIcon = (labelName, refName, name, checked, action) => (
  <div className="FormGroup">
    <label className="FormGroup-label capitalize">{labelName}</label>
    <div className="Input">
      <input
        placeholder={labelName.replace(/\b\w/g, (c) => c.toUpperCase())}
        type={checked ? '' : 'password'}
        ref={refName}
      />
      <label className="Input-Icon">
        <input type="checkbox" nam={name} style={{ display: 'none' }} checked={checked} />
        <i className={`b material-icons Icon ${checked ? 'green' : ''}`} onClick={() => action()}>
          visibility
        </i>
      </label>
    </div>
  </div>
)

const formField = (labelName, refName, name, defaultValue, disabled = false, onClick = null) => (
  <div className="FormGroup" onClick={onClick}>
    <label className="FormGroup-label capitalize">{labelName}</label>
    <div
      className={`Input ${disabled ? 'disabled' : ''} ${typeof onClick === 'function' ? 'support-change' : ''}`}
    >
      <div className="header">
        <input
          placeholder={labelName.replace(/\b\w/g, (c) => c.toUpperCase())}
          autoComplete={false}
          type="text"
          name={name}
          ref={refName}
          defaultValue={defaultValue}
        />
      </div>
    </div>
  </div>
)

const FormEditUser = (props) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const firstNameRef = useRef()
  const lastNameRef = useRef()
  const emailRef = useRef()
  const phoneRef = useRef()
  const companyNameRef = useRef()
  const curPasswordRef = useRef()
  const newPasswordRef = useRef()
  const confirmPasswordRef = useRef()

  const { currentCustomer, setIsShowEdit } = props
  const [isShowPopupLogout, setIsShowPopupLogout] = useState(false)
  const [checkStatus, setCheckStatus] = useState({
    curPassChecked: false,
    newPassChecked: false,
    confirmPassChecked: false,
  })
  const [isShowImageErrorUpload, setIsShowImageErrorUpload] = useState(false)

  const [isShowPopupConfirmChangeInfo, setIsShowPopupConfirmChangeInfo] = useState(false)
  const [changeType, setChangeType] = useState(null)

  if (_.isEmpty(currentCustomer)) {
    return null
  }

  const {
    avatar_square: avatarSquare,
    country_code: countryCode,
    first_name: firstName,
    last_name: lastName,
    email,
    phone,
    business_name: businessName,
  } = currentCustomer

  const showDialogUploadFile = () => {
    const input = document.getElementById('upload_image')
    if (input) {
      input.click()
    }
  }

  const handleUpdateUser = async () => {
    const photo = document.getElementById('upload_image').files[0]
    const params = {
      avatar_square: photo,
      first_name: firstNameRef.current.value,
      last_name: lastNameRef.current.value,
      email: emailRef.current.value,
      phone: phoneRef.current.value,
      business_name: companyNameRef.current.value,
      current_password: curPasswordRef.current.value,
      password: newPasswordRef.current.value,
      password_confirmation: confirmPasswordRef.current.value
    }
    
    const formData = generateFormData(currentCustomer, params, t)
    if(!formData) return
    showLoading()
    const response = await CustomerAPI.updateCustomer(formData)
    hideLoading()
    const data = _.get(response, 'data.object', {})
    const error = _.get(response, 'data.error', '')
    if (!_.isEmpty(error)) return Utils.showToastrMessage('info', error)
    if (_.isEmpty(data)) return null
    Utils.showToastrMessage('success', t('success.messages.updated'))
    dispatch(currentCustomerActionsCreator.updateCustomer(data))
    setIsShowEdit(false)
  }

  const handleCheckStatus = (name, value) => setCheckStatus({ ...checkStatus, [name]: value })

  const handleConfirmChangeInfo = (type) => {
    setIsShowPopupConfirmChangeInfo(false)
    // Add logic to handle email change confirmation
    Utils.openFreshChat({
      type: FRESH_CHAT_TYPE_REQUEST_CHANGE_INFO,
      bookingId: null,
      countryCode: countryCode.toUpperCase(),
      replyText: `${
        type === 'Email'
          ? t('webapp.customer_service.auto_message_email')
          : t('webapp.customer_service.auto_message_phone')
      }`,
    })
    CommonUtils.moengageTrackEvent('Customer clicks Chat With CS to update info', {
      'Info update': type,
    })
  }
  const handleShowPopupConfirmChangeInfo = (type) => {
    setChangeType(type)
    setIsShowPopupConfirmChangeInfo(true)
  }

  const renderAvatar = () => (
    <Fragment>
      <label className="xxb rounded Avatar flex-column" htmlFor="upload_image">
        <input
          style={{ display: 'none' }}
          type="file"
          name="customer[avatar]"
          id="upload_image"
          onChange={(e) => checkAndUploadFile(e.target, setIsShowImageErrorUpload)}
        />
        <img
          alt='avatar'
          className="ui image rounded"
          src={avatarSquare === 'missing.png' ? IMAGE_PLACE_HOLDER : avatarSquare}
          width="100"
          height="100"
          id="upload_image_view"
          onClick={() => showDialogUploadFile()}
        />
        <div className="Avatar-icon">
          <img className="Radius-zero" src={UPLOAD_IMAGE} alt='avatar-icon'/>
        </div>
      </label>
      <div
        className="mt10 flex-center green Dark-Green-text-hover cur-pointer"
        data-id="Modal-logout-as-admin"
        onClick={() => setIsShowPopupLogout(true)}
      >
        <img className="mr10" height="17" src={LOG_OUT_IMAGE} alt="logout" />
        <span className="default-font">{t('label.log_out')}</span>
      </div>
    </Fragment>
  )

  const renderContent = () => {
    const isTestingUser = CommonUtils.isTestingUser(currentCustomer.id, TEST_FEATURE_CHANGE_PHONE_EMAIL_CS)
    return (
      <div className="Box-Content vertical-scroll">
        <div className="Form">
          {renderAvatar()}
          {formField(t('webapp.label.first_name'), firstNameRef, 'first_name', firstName)}
          {formField(t('webapp.label.last_name'), lastNameRef, 'last_name', lastName)}
          {formField(
            t('webapp.label.email'),
            emailRef,
            'email',
            email,
            true,
            isTestingUser ? () => handleShowPopupConfirmChangeInfo('Email') : null
          )}
          {formField(
            t('webapp.adyen.mobileNumber'),
            phoneRef,
            'phone',
            phone,
            true,
            isTestingUser ? () => handleShowPopupConfirmChangeInfo('Mobile') : null
          )}
          {formField(t('webapp.label.business_name'), companyNameRef, 'business_name', businessName)}
          {formFieldWithIcon(
            t('webapp.label.current_password'),
            curPasswordRef,
            'current_password',
            checkStatus.curPassChecked,
            () => handleCheckStatus('curPassChecked', !checkStatus.curPassChecked)
          )}
          {formFieldWithIcon(
            t('webapp.label.new_password'),
            newPasswordRef,
            'new_password',
            checkStatus.newPassChecked,
            () => handleCheckStatus('newPassChecked', !checkStatus.newPassChecked)
          )}
          {formFieldWithIcon(
            t('webapp.label.confirm_new_password'),
            confirmPasswordRef,
            'confirm_new_password',
            checkStatus.confirmPassChecked,
            () => handleCheckStatus('confirmPassChecked', !checkStatus.confirmPassChecked)
          )}
        </div>
      </div>
    )
  }

  const renderPopupConfirmChangeInfo = () => (
    <Fragment>
      <div className="PopupBackground" />
      <div className="PopupConfirmChangeInfo">
        <div className="PopupContent">
          <div className="RequirementPopupWrapper visible">
            <div className="RequirementPopup">
              <div className="Box">
                <div className="IconPopup">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M26.9802 8.3594C25.687 3.54634 21.3691 0 16.2561 0C11.143 0 6.82499 3.54652 5.53193 8.35978C4.61068 8.97061 4 10.0313 4 11.235V12.9169C4 14.8051 5.50268 16.3414 7.34961 16.3414C7.97557 16.3414 8.58734 16.1617 9.11841 15.8221C9.22753 15.7523 9.32899 15.6737 9.42218 15.5873C10.1957 16.9581 11.3524 18.0756 12.7416 18.7859C9.10205 20.2302 6.51513 23.8491 6.51513 28.0741V28.7419C6.51513 30.5384 7.94469 31.9999 9.70194 31.9999H22.8102C24.5674 31.9999 25.997 30.5384 25.997 28.7419V28.0741C25.997 23.8491 23.4101 20.2302 19.7705 18.7859C21.1598 18.0756 22.3165 16.958 23.0901 15.5872C23.1832 15.6734 23.2846 15.752 23.3936 15.8217C23.9248 16.1616 24.5365 16.3412 25.1626 16.3412C27.0095 16.3412 28.5122 14.8049 28.5122 12.9166V11.2347C28.5122 10.0309 27.9014 8.97022 26.9802 8.3594ZM23.4562 8.29061C23.9005 8.01996 24.3981 7.85941 24.9116 7.81987C23.5322 4.31485 20.1721 1.83419 16.2561 1.83419C12.3399 1.83419 8.97983 4.315 7.60044 7.82018C8.11392 7.8597 8.61152 8.0202 9.05584 8.2908C10.2874 5.47759 13.0515 3.5127 16.2561 3.5127C19.4605 3.5127 22.2246 5.4775 23.4562 8.29061ZM22.0553 13.4733C22.2437 12.8739 22.3455 12.2351 22.3455 11.5724C22.3455 8.13969 19.6138 5.34701 16.2561 5.34701C12.8983 5.34701 10.1667 8.13976 10.1667 11.5724C10.1667 15.0051 12.8983 17.7979 16.2561 17.7979C18.2442 17.7979 20.0128 16.8188 21.1248 15.3076H16.8242C16.3288 15.3076 15.9271 14.897 15.9271 14.3904C15.9271 13.8839 16.3288 13.4733 16.8242 13.4733H22.0553ZM8.30923 28.074C8.30923 23.5943 11.8742 19.9496 16.2561 19.9496C20.638 19.9496 24.2029 23.5943 24.2029 28.074V28.7418C24.2029 29.5269 23.5781 30.1656 22.8102 30.1656H9.70193C8.93403 30.1656 8.30923 29.5269 8.30923 28.7418V28.074ZM7.34961 9.64453C6.49183 9.64453 5.79411 10.358 5.79411 11.2348V12.9167C5.79411 13.7937 6.49183 14.507 7.34961 14.507C7.63871 14.507 7.92128 14.424 8.16685 14.2668C8.26528 14.2039 8.32623 14.088 8.32623 13.9643V10.187C8.32623 10.0632 8.26516 9.94741 8.16698 9.88459C7.92128 9.72753 7.63859 9.64453 7.34961 9.64453ZM24.3453 9.88458C24.5909 9.72745 24.8735 9.64445 25.1626 9.64445C26.0204 9.64445 26.7181 10.3578 26.7181 11.2348V12.9168C26.7181 13.7936 26.0204 14.507 25.1626 14.507C24.8736 14.507 24.5909 14.424 24.3452 14.2668C24.247 14.204 24.186 14.0881 24.186 13.9644V10.1871C24.186 10.0634 24.2469 9.94751 24.3453 9.88458Z"
                      fill="#3FAE29"
                    />
                  </svg>
                </div>
                <div className="ContentWrapper">
                  <p className="Title"></p>
                  <p className="Content">{t('webapp.customer_service.chat_with_CS_to_edit_email_phone')}</p>
                </div>
                <div className="PopupActions">
                  <button type="button" className="gray Button" onClick={() => setIsShowPopupConfirmChangeInfo(false)}>
                    {t('webapp.action.back')}
                  </button>
                  <button type="button" className="Button" onClick={() => handleConfirmChangeInfo(changeType)}>
                    {t('batches.button.chat_with_cs')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )

  const renderPopup = () => (
    <Fragment>
      {isShowPopupLogout && (
        <ModalSignOut
          setIsShowPopupLogout={setIsShowPopupLogout}
          countryCode={countryCode}
        />
      )}
      {isShowImageErrorUpload && <AttachmentPopup fixed='fixed' />}
    </Fragment>
  )

  return (
    <div className="profile RightMenu visible">
      <div className="Box">
        <div className="Box-Head">
          <div className="cancel-edit Box-Head-back">
            <i className="xb material-icons Icon" onClick={() => setIsShowEdit(false)}>
              arrow_back
            </i>
          </div>
          <h3>{t('webapp.label.edit_profile')}</h3>
        </div>
        {renderContent()}
        <div className="Box-Actions">
          <button className="gray Button" type="button" onClick={() => setIsShowEdit(false)}>
            {t('webapp.action.cancel')}
          </button>
          <button className="green Button" type="button" onClick={() => handleUpdateUser()}>
            {t('webapp.action.save')}
          </button>
        </div>
      </div>
      {renderPopup()}
      {isShowPopupConfirmChangeInfo && renderPopupConfirmChangeInfo()}
    </div>
  )
}

FormEditUser.propTypes = {
  currentCustomer: PropTypes.shape({}).isRequired,
  setIsShowEdit: PropTypes.func.isRequired,
}

export default FormEditUser
